<template>
	<div class="c-culture__wrapper c-culture__country">
		<DsText
			html-element="h3"
			class="c-culture__header"
			text-style="medium"
			text-type="heading-2xl"
		>
			{{ headline }}
		</DsText>

		<div class="c-culture__description" v-html="descriptionHtml"></div>

		<div class="c-culture__field">
			<label
				class="c-culture__field-label ds-text-label-sm"
				for="csSelectCountry"
			>
				<span class="c-culture__field-text">
					{{ countryLabelText }}
				</span>
			</label>

			<select
				id="csSelectCountry"
				v-model="selectedCountryJson"
				class="c-culture__select"
				@change="handleCountryChange"
			>
				<option value="" disabled>{{ selectCountryLabelText }}</option>
				<option
					v-for="item in countryList"
					:key="item.Name + item.Url"
					:value="JSON.stringify(item)"
				>
					{{ item.Name }}
				</option>
			</select>
		</div>
	</div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from 'vue';
import { DsText } from '@coloplast/design-system';
import { useCultureNavigation } from './useCultureNavigation';
import { type Country } from './types';

const props = defineProps<{
	countryLabelText?: string;
	countryList: Country[];
	description?: string;
	headline?: string;
	lang?: string;
	langUrl?: string;
	selectCountryLabelText?: string;
	setPopupMode: (mode: string) => void;
	show: string;
}>();

const { setCultureAndNavigate, setCultureCookie } = useCultureNavigation();

const selectedCountryJson = ref<string>('');

const selectedCountry = computed<Country | null>(() => {
	try {
		return JSON.parse(selectedCountryJson.value);
	} catch {
		return null;
	}
});

const descriptionHtml = computed(() => {
	return `<div>${props.description || ''}</div>`;
});

const handleCountryChange = () => {
	if (!selectedCountry.value) return;

	setCultureAndNavigate(
		selectedCountry.value.Name,
		selectedCountry.value.Url
	);
};

onMounted(() => {
	const preselected = props.countryList.find((c) => c.IsSelected);
	if (preselected) {
		selectedCountryJson.value = JSON.stringify(preselected);
		setCultureCookie(preselected.Name);
		props.setPopupMode('country');
	}
});
</script>
